import { getOidcSettings } from '@/config/oidcSettings'
import { useEnvStore } from '@/stores/envStore'
import axios from 'axios'
import { InjectionKey } from 'vue'

import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { vuexOidcCreateUserManager } from 'vuex-oidc'

export default class AuthorizationInterceptor {
  envStore = useEnvStore()
  public enable() {
    const userManager = vuexOidcCreateUserManager(getOidcSettings(this.envStore.variables))
    const router = useRouter()
    const authStore = useStore()
    axios.interceptors.request.use(async (request) => {
      if (
        request.url?.startsWith(this.envStore.variables.ANALYZE_API_BACKEND_URL) ||
        request.url?.startsWith(this.envStore.variables.ANALYZE_PLATFORM_URL)
      ) {
        const accessToken = authStore.state.oidcStore.access_token
        const expiresAt = authStore.state.oidcStore.expires_at
        const currentTime = new Date().getTime()

        if (accessToken && expiresAt && currentTime >= expiresAt) {
          // Attempt to refresh the token
          try {
            const user = await userManager.getUser()
            if (user && user.refresh_token) {
              const refreshUser = await userManager.signinSilent()
              authStore.commit('setOidcAuth', refreshUser)
              if (refreshUser?.access_token)
                request.headers.Authorization = `Bearer ${refreshUser.access_token}`
            }
          } catch (error) {
            // Handle refresh token failure
            console.error('token refresh failed, login out', error)
            router.push({
              name: 'LandingPageVue',
              query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) },
            })
          }
        } else if (accessToken) {
          request.headers.Authorization = `Bearer ${accessToken}`
        }
      }
      return request
    })

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          router.push({
            name: 'LandingPageVue',
            query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) },
          })
        }
        return Promise.reject(error)
      },
    )
  }
}
export const AUTHZ_INTERCEPTOR_KEY: InjectionKey<AuthorizationInterceptor> = Symbol(
  'AuthorizationInterceptor',
)
